"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderCancelRequestResponseSchema = exports.orderCancelRequestSchema = exports.CANCEL_REASON_MAX = exports.orderCancelTicketChoiceInputSchema = exports.orderCancelEligibilityResponseSchema = exports.CANCEL_REQUEST_CHANGES_REFUSED_MESSAGE = exports.CANCEL_NO_APPROVAL_RULE_MESSAGE = exports.CANCEL_BL_APPEARED_MESSAGE = exports.CANCEL_INELIGIBILITY_MESSAGES = exports.cancelIneligibilityCodeSchema = exports.CANCEL_INELIGIBILITY_CODES = exports.orderCancelTicketChoiceSchema = exports.ORDER_CANCEL_TICKET_CHOICES = void 0;
exports.orderCancelledWriteRefusalMessage = orderCancelledWriteRefusalMessage;
const zod_1 = require("zod");
// The per-ticket outcome the submitter picks at request time. Mirrors the
// Prisma `order_cancel_ticket_choice` enum. `keep` is the frontend's default;
// the backend never defaults a choice — a submit must name one per ticket.
exports.ORDER_CANCEL_TICKET_CHOICES = ['keep', 'delete'];
exports.orderCancelTicketChoiceSchema = zod_1.z.enum(exports.ORDER_CANCEL_TICKET_CHOICES);
// One code per eligibility check. The codes are stable wire values; the
// messages below are the copy the product owns, and both the eligibility read
// and the submit refusal serve the same pair so the two can never diverge.
exports.CANCEL_INELIGIBILITY_CODES = [
    'not_b2b',
    'no_ticket_link',
    'multi_ticket',
    'live_bl',
    'declared_to_lender',
    'already_cancelled',
    'request_pending',
];
exports.cancelIneligibilityCodeSchema = zod_1.z.enum(exports.CANCEL_INELIGIBILITY_CODES);
// Product-owned copy, one message per code. The frontend renders these; the
// backend refuses with them. The string itself is the contract — never reword
// one to suit a call site.
exports.CANCEL_INELIGIBILITY_MESSAGES = {
    not_b2b: 'Only matched buy and sell orders can be cancelled.',
    no_ticket_link: 'No tickets are linked to this order.',
    multi_ticket: 'This order was matched from several tickets. Cancellation is not available for it yet.',
    live_bl: 'This order has a BL. Remove the BL first. A BL that cannot be removed means the order is past pre-shipment.',
    declared_to_lender: 'This order was declared to a lender. Cancellation is not available for an order that has shipped.',
    already_cancelled: 'This order is already cancelled.',
    request_pending: 'A cancel request is already pending on this order.',
};
// Raised by the outcome's re-check when a BL appeared while the request was
// pending. Deliberately its own string: the approver is told what changed
// under them, not why the order was never eligible.
exports.CANCEL_BL_APPEARED_MESSAGE = 'This order now has a BL and cannot be cancelled.';
// The submit refusal when no enabled approval rule covers cancellation. This
// path never auto-approves, unlike the ticket and hedge submit paths.
exports.CANCEL_NO_APPROVAL_RULE_MESSAGE = 'No approval rule covers cancellation. Ask an admin to enable it.';
// The act-on refusal for `request_changes` on a cancel request. A submitter
// cannot edit a pending request, so a changes-requested state is a dead end.
exports.CANCEL_REQUEST_CHANGES_REFUSED_MESSAGE = 'Request changes is not available on a cancel request. Approve or reject it.';
// The one message every refused write to a Cancelled order answers with.
function orderCancelledWriteRefusalMessage(orderId) {
    return `Order ${orderId} is cancelled and cannot be changed.`;
}
exports.orderCancelEligibilityResponseSchema = zod_1.z.object({
    eligible: zod_1.z.boolean(),
    code: exports.cancelIneligibilityCodeSchema.nullable(),
    message: zod_1.z.string().nullable(),
});
exports.orderCancelTicketChoiceInputSchema = zod_1.z
    .object({
    ticket_id: zod_1.z.string().regex(/^\d+$/, 'ticket_id must be a positive integer id'),
    choice: exports.orderCancelTicketChoiceSchema,
})
    .strict();
exports.CANCEL_REASON_MAX = 2000;
exports.orderCancelRequestSchema = zod_1.z
    .object({
    // Mandatory and non-blank: the trim happens before the length check, so a
    // whitespace-only reason is refused at the schema, not in the service.
    reason: zod_1.z.string().trim().min(1, 'A reason is required').max(exports.CANCEL_REASON_MAX),
    // Exactly one choice per ticket linked to the order. The set is validated
    // against the order's own ticket-link row on submit, not trusted as given.
    ticket_choices: zod_1.z.array(exports.orderCancelTicketChoiceInputSchema).min(1).max(2),
})
    .strict();
exports.orderCancelRequestResponseSchema = zod_1.z.object({
    request_id: zod_1.z.string().uuid(),
    workflow_id: zod_1.z.string().uuid(),
    order_id: zod_1.z.string(),
    reason: zod_1.z.string(),
    submitted_by_user_id: zod_1.z.string().uuid().nullable(),
    submitted_at: zod_1.z.string(),
    ticket_choices: zod_1.z.array(zod_1.z.object({
        ticket_id: zod_1.z.string(),
        choice: exports.orderCancelTicketChoiceSchema,
    })),
});
//# sourceMappingURL=order-cancellation.js.map